import { useStaticQuery, graphql } from "gatsby"

const useStringVariables = (content, exclude = []) => {
  const data = useStaticQuery(graphql`
    query VarsQuery {
      allDataJson(filter: { optionsItem: { eq: "string-variables" } }) {
        nodes {
          vars {
            key
            value
          }
          optionsItem
        }
      }
    }
  `)

  const map = new Map()
  data.allDataJson.nodes[0].vars.forEach(obj => {
    // do not add key/value pair if string is found in exclude array
    //currently exludes when string var url matches the page url
    // if (exclude.find(item => obj.value === item)) {
    //   return
    // }

    map.set(obj.key, obj.value)
  })

  const string = replaceStringVars(content, Object.fromEntries(map.entries()))

  return {
    string
  }
}

export default useStringVariables

function replaceStringVars(str, obj) {
  let s = str
  for (var prop in obj) {
    s = s.replace(
      new RegExp("(?!<a[^>]*>)(" + prop + ")(?![^<]*<\\/a>)", "g"),
      obj[prop]
    )
  }
  return s
}
